import { executeTrade } from '../executeTrade';
import type { ExecutionContext, SubmitLane, TradeSubmitOutcome } from '../types';
import { advancedStrategy } from './advanced';
import { batchStrategy } from './batch';
import { crossChainStrategy } from './crossChain';
import { evmStrategy } from './evm';
import { intentsStrategy } from './intents';
import { solanaStrategy } from './solana';
import { solanaWrapStrategy } from './solanaWrap';
import { wrapStrategy } from './wrap';

/** Executes the strategy for a submit lane without erasing its prepared-state type. */
export function executeRegisteredTrade(
  lane: SubmitLane,
  ctx: ExecutionContext,
): Promise<TradeSubmitOutcome> {
  switch (lane) {
    case 'evm':
      return executeTrade({ strategy: evmStrategy, ctx });
    case 'batch':
      return executeTrade({ strategy: batchStrategy, ctx });
    case 'solana':
      return executeTrade({ strategy: solanaStrategy, ctx });
    case 'solana-wrap':
      return executeTrade({ strategy: solanaWrapStrategy, ctx });
    case 'intents':
      return executeTrade({ strategy: intentsStrategy, ctx });
    case 'wrap':
      return executeTrade({ strategy: wrapStrategy, ctx });
    case 'cross-chain':
      return executeTrade({ strategy: crossChainStrategy, ctx });
    case 'advanced':
      return executeTrade({ strategy: advancedStrategy, ctx });
  }
}
